import { DataError } from '@eastcoal/common/components/DataError'
import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '../Store/hooks/useStore'

export const CrudFormReadError = () => {
  const { readError, readLoading, reloadDetail } = useCrudFormStore(state =>
    pick(state, ['readError', 'readLoading', 'reloadDetail'])
  )

  return (
    readError && (
      <DataError
        block
        error={readError}
        loading={readLoading}
        reload={reloadDetail}
      />
    )
  )
}
